import React from 'react';

import Hero from './home/Hero';
import TrustedBy from './home/TrustedBy';
import PopularCourses from './home/PopularCourses';
import WhyChoose from './home/WhyChoose';
// import FreeResources from './home/FreeResources';
import CreatorRoadmap from './home/CreatorRoadmap';
import TopInstructors from './home/TopInstructors';
import RealResults from './home/RealResults';
// import SuccessilatorPro from './home/SuccessilatorPro';
import LiveEvents from './home/LiveEvents';


function Home({ onSelectCourse }) {
  return (
    <div className="homepage-root">
      
      <Hero />
      <TrustedBy />
      <PopularCourses onSelectCourse={onSelectCourse} /><CreatorRoadmap /><RealResults />
      <WhyChoose />
      {/* <FreeResources /> */}
      
      
      <TopInstructors />
      
      {/* <SuccessilatorPro /> */}
      <LiveEvents />
      
    </div>
  );
}

export default Home;